"use client"
import {
  HueSlider
} from "./chunk-7BPTMXYR.mjs";

// src/components/alpha-slider.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var AlphaSlider = mergeMultiStyle(HueSlider)();

export {
  AlphaSlider
};
//# sourceMappingURL=chunk-URR6AK2J.mjs.map